// Based on polished. Reduced to our minimal use case, as all our color tokens are hex values.
// https://github.com/styled-components/polished/blob/master/src/color/rgba.js
// https://github.com/styled-components/polished/blob/master/src/color/parseToRgb.js
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var parseToRgb = function (color) {
    if (color.match(hexRegex)) {
        return {
            red: parseInt("".concat(color[1]).concat(color[2]), 16),
            green: parseInt("".concat(color[3]).concat(color[4]), 16),
            blue: parseInt("".concat(color[5]).concat(color[6]), 16),
        };
    }
    if (color.match(reducedHexRegex)) {
        return {
            red: parseInt("".concat(color[1]).concat(color[1]), 16),
            green: parseInt("".concat(color[2]).concat(color[2]), 16),
            blue: parseInt("".concat(color[3]).concat(color[3]), 16),
        };
    }
    return null;
};
export var rgba = function (color, opacity) {
    var rgbValue = parseToRgb(color);
    if (rgbValue) {
        return "rgba(".concat(rgbValue.red, ",").concat(rgbValue.green, ",").concat(rgbValue.blue, ",").concat(opacity, ")");
    }
    return color;
};
//# sourceMappingURL=rgba.js.map